/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.WorldImagerySettingsResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorldImagerySettingsResource model module.
   * @module model/WorldImagerySettingsResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>WorldImagerySettingsResource</code>.
   * A class that represents the configuration settings for the World Streets service.
   * @alias module:model/WorldImagerySettingsResource
   * @class
   * @param naipBucketName {String} Buscket name for Naip on Amazon Web Server.
   * @param naipAccessKeyId {String} Access key for the Naip bucket on Amazon Web Server.
   * @param naipSecretAccessKey {String} Secret access key for the Naip bucket on Amazon Web Server.
   * @param naipRegionEndpoint {String} Region display name for the Naip bucket on Amazon Web Server.
   * @param naipShapeFileIndex {String} The path to the Shapefile Data for Naip.
   * @param naipCacheDirectory {String} The path to the folder containing Naip data.
   * @param cacheDirectory {String} The path to the local folder containing the active cache of palette-optimized raster map tile images.
   * @param tileCacheBucketName {String} The bucket name for tile cache on Amazon Web Server.
   * @param tileCacheAccessKeyId {String} The Access Key for tile cache on Amazon Web Server.
   * @param tileCacheSecretAccessKey {String} The Secret Access Key for tile cache on Amazon Web Server.
   * @param tileCacheRegionEndpoint {String} The region display name of S3TileCache.
   * @param tileResponseCacheDurationInSeconds {String} Defines how long browsers should be allowed to locally cache map tiles.
   */
  var exports = function(naipBucketName, naipAccessKeyId, naipSecretAccessKey, naipRegionEndpoint, naipShapeFileIndex, naipCacheDirectory, cacheDirectory, tileCacheBucketName, tileCacheAccessKeyId, tileCacheSecretAccessKey, tileCacheRegionEndpoint, tileResponseCacheDurationInSeconds) {
    var _this = this;


    _this['naipBucketName'] = naipBucketName;
    _this['naipAccessKeyId'] = naipAccessKeyId;
    _this['naipSecretAccessKey'] = naipSecretAccessKey;
    _this['naipRegionEndpoint'] = naipRegionEndpoint;
    _this['naipShapeFileIndex'] = naipShapeFileIndex;
    _this['naipCacheDirectory'] = naipCacheDirectory;
    _this['cacheDirectory'] = cacheDirectory;
    _this['tileCacheBucketName'] = tileCacheBucketName;
    _this['tileCacheAccessKeyId'] = tileCacheAccessKeyId;
    _this['tileCacheSecretAccessKey'] = tileCacheSecretAccessKey;
    _this['tileCacheRegionEndpoint'] = tileCacheRegionEndpoint;
    _this['tileResponseCacheDurationInSeconds'] = tileResponseCacheDurationInSeconds;
  };

  /**
   * Constructs a <code>WorldImagerySettingsResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorldImagerySettingsResource} obj Optional instance to populate.
   * @return {module:model/WorldImagerySettingsResource} The populated <code>WorldImagerySettingsResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('isCacheReadOnly')) {
        obj['isCacheReadOnly'] = ApiClient.convertToType(data['isCacheReadOnly'], 'Boolean');
      }
      if (data.hasOwnProperty('naipBucketName')) {
        obj['naipBucketName'] = ApiClient.convertToType(data['naipBucketName'], 'String');
      }
      if (data.hasOwnProperty('naipAccessKeyId')) {
        obj['naipAccessKeyId'] = ApiClient.convertToType(data['naipAccessKeyId'], 'String');
      }
      if (data.hasOwnProperty('naipSecretAccessKey')) {
        obj['naipSecretAccessKey'] = ApiClient.convertToType(data['naipSecretAccessKey'], 'String');
      }
      if (data.hasOwnProperty('naipRegionEndpoint')) {
        obj['naipRegionEndpoint'] = ApiClient.convertToType(data['naipRegionEndpoint'], 'String');
      }
      if (data.hasOwnProperty('naipShapeFileIndex')) {
        obj['naipShapeFileIndex'] = ApiClient.convertToType(data['naipShapeFileIndex'], 'String');
      }
      if (data.hasOwnProperty('naipCacheDirectory')) {
        obj['naipCacheDirectory'] = ApiClient.convertToType(data['naipCacheDirectory'], 'String');
      }
      if (data.hasOwnProperty('cacheDirectory')) {
        obj['cacheDirectory'] = ApiClient.convertToType(data['cacheDirectory'], 'String');
      }
      if (data.hasOwnProperty('tileCacheBucketName')) {
        obj['tileCacheBucketName'] = ApiClient.convertToType(data['tileCacheBucketName'], 'String');
      }
      if (data.hasOwnProperty('tileCacheAccessKeyId')) {
        obj['tileCacheAccessKeyId'] = ApiClient.convertToType(data['tileCacheAccessKeyId'], 'String');
      }
      if (data.hasOwnProperty('tileCacheSecretAccessKey')) {
        obj['tileCacheSecretAccessKey'] = ApiClient.convertToType(data['tileCacheSecretAccessKey'], 'String');
      }
      if (data.hasOwnProperty('tileCacheRegionEndpoint')) {
        obj['tileCacheRegionEndpoint'] = ApiClient.convertToType(data['tileCacheRegionEndpoint'], 'String');
      }
      if (data.hasOwnProperty('tileResponseCacheDurationInSeconds')) {
        obj['tileResponseCacheDurationInSeconds'] = ApiClient.convertToType(data['tileResponseCacheDurationInSeconds'], 'String');
      }
    }
    return obj;
  }

  /**
   * Indicates if the imagery tile cache is read-only or not.
   * @member {Boolean} isCacheReadOnly
   */
  exports.prototype['isCacheReadOnly'] = undefined;
  /**
   * Buscket name for Naip on Amazon Web Server.
   * @member {String} naipBucketName
   */
  exports.prototype['naipBucketName'] = undefined;
  /**
   * Access key for the Naip bucket on Amazon Web Server.
   * @member {String} naipAccessKeyId
   */
  exports.prototype['naipAccessKeyId'] = undefined;
  /**
   * Secret access key for the Naip bucket on Amazon Web Server.
   * @member {String} naipSecretAccessKey
   */
  exports.prototype['naipSecretAccessKey'] = undefined;
  /**
   * Region display name for the Naip bucket on Amazon Web Server.
   * @member {String} naipRegionEndpoint
   */
  exports.prototype['naipRegionEndpoint'] = undefined;
  /**
   * The path to the Shapefile Data for Naip.
   * @member {String} naipShapeFileIndex
   */
  exports.prototype['naipShapeFileIndex'] = undefined;
  /**
   * The path to the folder containing Naip data.
   * @member {String} naipCacheDirectory
   */
  exports.prototype['naipCacheDirectory'] = undefined;
  /**
   * The path to the local folder containing the active cache of palette-optimized raster map tile images.
   * @member {String} cacheDirectory
   */
  exports.prototype['cacheDirectory'] = undefined;
  /**
   * The bucket name for tile cache on Amazon Web Server.
   * @member {String} tileCacheBucketName
   */
  exports.prototype['tileCacheBucketName'] = undefined;
  /**
   * The Access Key for tile cache on Amazon Web Server.
   * @member {String} tileCacheAccessKeyId
   */
  exports.prototype['tileCacheAccessKeyId'] = undefined;
  /**
   * The Secret Access Key for tile cache on Amazon Web Server.
   * @member {String} tileCacheSecretAccessKey
   */
  exports.prototype['tileCacheSecretAccessKey'] = undefined;
  /**
   * The region display name of S3TileCache.
   * @member {String} tileCacheRegionEndpoint
   */
  exports.prototype['tileCacheRegionEndpoint'] = undefined;
  /**
   * Defines how long browsers should be allowed to locally cache map tiles.
   * @member {String} tileResponseCacheDurationInSeconds
   */
  exports.prototype['tileResponseCacheDurationInSeconds'] = undefined;



  return exports;
}));



